import { Injectable } from "@angular/core";
import { ApiLoadingService } from "./api-loading.service";
import { ApiCallService } from "./api-call.service";
import { Block } from "./../models/index";
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { LocaleService } from "../seo/locale.service";

@Injectable()
export class BlocksService implements Resolve<Block[]> {
  constructor(
    private apiLoadingService: ApiLoadingService,
    private apiCallService: ApiCallService,
    private httpClient: HttpClient,
    private localeService: LocaleService
  ) {}

  getBlocks(category: string, fetchLocalData: boolean = false): Promise<any> {
    return fetchLocalData
      ? this.fetchLocalData(`../../../assets/data/blocks/${category}.json`)
      : this.apiCallService.get(`/block_categories/${category}/blocks`);
  }

  private async fetchLocalData(path: string) {
    return await this.httpClient.get(`../../../${path}`).toPromise();
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let promise: any;
    const categories = route.data["blocks_categories"];
    const localeDataPath = route.data["localeDataPath"];

    if (localeDataPath) {
      let path = localeDataPath;
      if (route.data["hasMultipleTranslations"]) {
        path = `${path}_${this.localeService.getCurrentLocale()}.json`;
      } else {
        path = `${path}.json`;
      }

      return this.fetchLocalData(path);
    }

    if (categories.length > 1) {
      const all = [];

      categories.forEach((category) => {
        all.push(this.getBlocks(category));
      });

      promise = Promise.all(all);
    } else {
      promise = this.getBlocks(categories[0]);
    }

    this.apiLoadingService.startLoading(promise);
    return promise;
  }
}
